var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('van-empty',{attrs:{"description":"页面不存在"}}),_c('p',{staticClass:"countdown"},[_vm._v(_vm._s(_vm.countdown)+" 秒后自动返回首页")]),_c('van-button',{attrs:{"type":"primary","round":"","size":"small"},on:{"click":_vm.goHome}},[_vm._v(" 返回首页 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }